(function (root, factory) {
  if (typeof module === 'object' && module.exports) {
    module.exports = factory();
  } else {
    root.SnackAutomatRoi = factory();
  }
})(typeof window !== 'undefined' ? window : globalThis, function () {
  'use strict';

  var QUALITY_RATES = {
    low: 2,
    'rather-low': 4,
    medium: 6,
    good: 8,
    high: 10,
    'very-high': 12
  };

  var LOCATION_DEFAULTS = {
    office: {
      activeDaysPerMonth: 22,
      activeHoursPerDay: 8,
      potentialUsersPerDay: 120,
      conversionRatePercent: 12,
      locationQuality: 'very-high',
      locationQualityLabel: 'Sehr hoch - ca. 12 % Kaufquote',
      itemsPerPurchase: 2
    },
    gym: {
      activeDaysPerMonth: 28,
      activeHoursPerDay: 14,
      potentialUsersPerDay: 300,
      conversionRatePercent: 8,
      locationQuality: 'good',
      locationQualityLabel: 'Gut - ca. 8 % Kaufquote',
      itemsPerPurchase: 1.4
    },
    school: {
      activeDaysPerMonth: 20,
      activeHoursPerDay: 7,
      potentialUsersPerDay: 500,
      conversionRatePercent: 6,
      locationQuality: 'medium',
      locationQualityLabel: 'Mittel - ca. 6 % Kaufquote',
      itemsPerPurchase: 1.4
    },
    care: {
      activeDaysPerMonth: 30,
      activeHoursPerDay: 18,
      potentialUsersPerDay: 550,
      conversionRatePercent: 6,
      locationQuality: 'medium',
      locationQualityLabel: 'Mittel - ca. 6 % Kaufquote',
      itemsPerPurchase: 1.15
    },
    warehouse: {
      activeDaysPerMonth: 24,
      activeHoursPerDay: 12,
      potentialUsersPerDay: 220,
      conversionRatePercent: 10,
      locationQuality: 'high',
      locationQualityLabel: 'Hoch - ca. 10 % Kaufquote',
      itemsPerPurchase: 1.4
    },
    hotel: {
      activeDaysPerMonth: 30,
      activeHoursPerDay: 16,
      potentialUsersPerDay: 250,
      conversionRatePercent: 6,
      locationQuality: 'medium',
      locationQualityLabel: 'Mittel - ca. 6 % Kaufquote',
      itemsPerPurchase: 1.9
    },
    coworking: {
      activeDaysPerMonth: 24,
      activeHoursPerDay: 10,
      potentialUsersPerDay: 150,
      conversionRatePercent: 10,
      locationQuality: 'high',
      locationQualityLabel: 'Hoch - ca. 10 % Kaufquote',
      itemsPerPurchase: 1.5
    },
    workshop: {
      activeDaysPerMonth: 22,
      activeHoursPerDay: 8,
      potentialUsersPerDay: 150,
      conversionRatePercent: 10,
      locationQuality: 'high',
      locationQualityLabel: 'Hoch - ca. 10 % Kaufquote',
      itemsPerPurchase: 1.2
    },
    public: {
      activeDaysPerMonth: 30,
      activeHoursPerDay: 18,
      potentialUsersPerDay: 2000,
      conversionRatePercent: 2,
      locationQuality: 'low',
      locationQualityLabel: 'Niedrig - ca. 2 % Kaufquote',
      itemsPerPurchase: 1.3
    },
    other: {
      activeDaysPerMonth: 24,
      activeHoursPerDay: 10,
      potentialUsersPerDay: 200,
      conversionRatePercent: 8,
      locationQuality: 'good',
      locationQualityLabel: 'Gut - ca. 8 % Kaufquote',
      itemsPerPurchase: 1.5
    }
  };

  var LOCATION_ASSORTMENT_PROFILES = {
    office: 'Büro & Mitarbeiter',
    gym: 'Fitness & Protein',
    school: 'Schule / Hochschule',
    care: 'Klassischer Snackmix',
    warehouse: 'Mitarbeiter & Schichtbetrieb',
    hotel: 'Hotel / öffentlich',
    coworking: 'Büro & Mitarbeiter',
    workshop: 'Klassischer Snackmix',
    public: 'Getränke & Impuls',
    other: 'Klassischer Snackmix'
  };

  var DEFAULT_CATEGORIES = [
    {
      id: 'snacks',
      name: 'Snacks',
      enabled: true,
      mixShare: 25,
      grossSellingPrice: 2,
      purchasePriceNet: 0.75,
      vatRate: 7,
      wasteRate: 2,
      shrinkageRate: 0
    },
    {
      id: 'sweets',
      name: 'Süßwaren',
      enabled: true,
      mixShare: 20,
      grossSellingPrice: 1.7,
      purchasePriceNet: 0.6,
      vatRate: 7,
      wasteRate: 2,
      shrinkageRate: 0
    },
    {
      id: 'drinks',
      name: 'Kalte Getränke',
      enabled: true,
      mixShare: 35,
      grossSellingPrice: 2.4,
      purchasePriceNet: 0.85,
      vatRate: 19,
      wasteRate: 1,
      shrinkageRate: 0
    },
    {
      id: 'healthy',
      name: 'Gesunde Snacks',
      enabled: true,
      mixShare: 10,
      grossSellingPrice: 2.8,
      purchasePriceNet: 1.2,
      vatRate: 7,
      wasteRate: 4,
      shrinkageRate: 0
    },
    {
      id: 'protein',
      name: 'Protein-/Fitnessprodukte',
      enabled: true,
      mixShare: 5,
      grossSellingPrice: 3.5,
      purchasePriceNet: 1.55,
      vatRate: 7,
      wasteRate: 3,
      shrinkageRate: 0
    },
    {
      id: 'other',
      name: 'Sonstige Produkte',
      enabled: true,
      mixShare: 5,
      grossSellingPrice: 2.5,
      purchasePriceNet: 1.05,
      vatRate: 19,
      wasteRate: 2,
      shrinkageRate: 0
    }
  ];

  var ASSORTMENT_PROFILES = {
    'Klassischer Snackmix': {
      Snacks: { share: 25, grossPrice: 2, netCost: 0.75, vat: 7, waste: 2 },
      Süßwaren: { share: 20, grossPrice: 1.7, netCost: 0.6, vat: 7, waste: 2 },
      'Kalte Getränke': { share: 35, grossPrice: 2.4, netCost: 0.85, vat: 19, waste: 1 },
      'Gesunde Snacks': { share: 10, grossPrice: 2.8, netCost: 1.2, vat: 7, waste: 4 },
      'Protein-/Fitnessprodukte': { share: 5, grossPrice: 3.5, netCost: 1.55, vat: 7, waste: 3 },
      'Sonstige Produkte': { share: 5, grossPrice: 2.5, netCost: 1.05, vat: 19, waste: 2 }
    },
    'Büro & Mitarbeiter': {
      Snacks: { share: 25, grossPrice: 2, netCost: 0.75, vat: 7, waste: 2 },
      Süßwaren: { share: 15, grossPrice: 1.7, netCost: 0.6, vat: 7, waste: 2 },
      'Kalte Getränke': { share: 35, grossPrice: 2.4, netCost: 0.85, vat: 19, waste: 1 },
      'Gesunde Snacks': { share: 15, grossPrice: 2.8, netCost: 1.2, vat: 7, waste: 4 },
      'Protein-/Fitnessprodukte': { share: 5, grossPrice: 3.5, netCost: 1.55, vat: 7, waste: 3 },
      'Sonstige Produkte': { share: 5, grossPrice: 2.5, netCost: 1.05, vat: 19, waste: 2 }
    },
    'Fitness & Protein': {
      Snacks: { share: 10, grossPrice: 2, netCost: 0.75, vat: 7, waste: 2 },
      Süßwaren: { share: 5, grossPrice: 1.7, netCost: 0.6, vat: 7, waste: 2 },
      'Kalte Getränke': { share: 35, grossPrice: 2.4, netCost: 0.85, vat: 19, waste: 1 },
      'Gesunde Snacks': { share: 20, grossPrice: 2.8, netCost: 1.2, vat: 7, waste: 4 },
      'Protein-/Fitnessprodukte': { share: 25, grossPrice: 3.5, netCost: 1.55, vat: 7, waste: 3 },
      'Sonstige Produkte': { share: 5, grossPrice: 2.5, netCost: 1.05, vat: 19, waste: 2 }
    },
    'Schule / Hochschule': {
      Snacks: { share: 25, grossPrice: 2, netCost: 0.75, vat: 7, waste: 2 },
      Süßwaren: { share: 25, grossPrice: 1.7, netCost: 0.6, vat: 7, waste: 2 },
      'Kalte Getränke': { share: 35, grossPrice: 2.4, netCost: 0.85, vat: 19, waste: 1 },
      'Gesunde Snacks': { share: 10, grossPrice: 2.8, netCost: 1.2, vat: 7, waste: 4 },
      'Protein-/Fitnessprodukte': { share: 0, grossPrice: 3.5, netCost: 1.55, vat: 7, waste: 3 },
      'Sonstige Produkte': { share: 5, grossPrice: 2.5, netCost: 1.05, vat: 19, waste: 2 }
    },
    'Mitarbeiter & Schichtbetrieb': {
      Snacks: { share: 30, grossPrice: 2, netCost: 0.75, vat: 7, waste: 2 },
      Süßwaren: { share: 20, grossPrice: 1.7, netCost: 0.6, vat: 7, waste: 2 },
      'Kalte Getränke': { share: 35, grossPrice: 2.4, netCost: 0.85, vat: 19, waste: 1 },
      'Gesunde Snacks': { share: 5, grossPrice: 2.8, netCost: 1.2, vat: 7, waste: 4 },
      'Protein-/Fitnessprodukte': { share: 5, grossPrice: 3.5, netCost: 1.55, vat: 7, waste: 3 },
      'Sonstige Produkte': { share: 5, grossPrice: 2.5, netCost: 1.05, vat: 19, waste: 2 }
    },
    'Hotel / öffentlich': {
      Snacks: { share: 20, grossPrice: 2, netCost: 0.75, vat: 7, waste: 2 },
      Süßwaren: { share: 15, grossPrice: 1.7, netCost: 0.6, vat: 7, waste: 2 },
      'Kalte Getränke': { share: 40, grossPrice: 2.4, netCost: 0.85, vat: 19, waste: 1 },
      'Gesunde Snacks': { share: 10, grossPrice: 2.8, netCost: 1.2, vat: 7, waste: 4 },
      'Protein-/Fitnessprodukte': { share: 5, grossPrice: 3.5, netCost: 1.55, vat: 7, waste: 3 },
      'Sonstige Produkte': { share: 10, grossPrice: 2.5, netCost: 1.05, vat: 19, waste: 2 }
    },
    'Getränke & Impuls': {
      Snacks: { share: 15, grossPrice: 2, netCost: 0.75, vat: 7, waste: 2 },
      Süßwaren: { share: 15, grossPrice: 1.7, netCost: 0.6, vat: 7, waste: 2 },
      'Kalte Getränke': { share: 50, grossPrice: 2.4, netCost: 0.85, vat: 19, waste: 1 },
      'Gesunde Snacks': { share: 5, grossPrice: 2.8, netCost: 1.2, vat: 7, waste: 4 },
      'Protein-/Fitnessprodukte': { share: 5, grossPrice: 3.5, netCost: 1.55, vat: 7, waste: 3 },
      'Sonstige Produkte': { share: 10, grossPrice: 2.5, netCost: 1.05, vat: 19, waste: 2 }
    }
  };

  var ACQUISITION_DEFAULTS = {
    purchase: {
      purchasePriceNet: 6950,
      deliveryCost: 250,
      installationCost: 0,
      setupCost: 0
    },
    leasing: {
      leasingRateNet: 150,
      termMonths: 48,
      setupCost: 250,
      downPayment: 0
    }
  };

  var LOCATION_COST_DEFAULTS = {
    none: { fixedLocationRent: 0, revenueSharePercentage: 0, revenueShareBase: 'net' },
    fixed: { fixedLocationRent: 100, revenueSharePercentage: 0, revenueShareBase: 'net' },
    share: { fixedLocationRent: 0, revenueSharePercentage: 10, revenueShareBase: 'net' },
    combined: { fixedLocationRent: 50, revenueSharePercentage: 5, revenueShareBase: 'net' },
    unknown: { fixedLocationRent: 0, revenueSharePercentage: 0, revenueShareBase: 'net' }
  };

  var PAYMENT_PROFILES = {
    mixed: { cardPaymentShare: 70, paymentFeePercentage: 1.5, fixedPaymentFee: 0.05, monthlyTerminalFee: 10 },
    card: { cardPaymentShare: 90, paymentFeePercentage: 1.5, fixedPaymentFee: 0.05, monthlyTerminalFee: 10 },
    cash: { cardPaymentShare: 30, paymentFeePercentage: 1.5, fixedPaymentFee: 0.05, monthlyTerminalFee: 10 }
  };

  var OPERATION_PROFILES = {
    self: { refillsPerMonth: 4, hoursPerRefill: 1, hourlyRate: 25, travelCostPerRefill: 10, maintenanceCost: 49 },
    service: { refillsPerMonth: 0, hoursPerRefill: 0, hourlyRate: 0, travelCostPerRefill: 0, maintenanceCost: 149 },
    unclear: { refillsPerMonth: 4, hoursPerRefill: 1, hourlyRate: 25, travelCostPerRefill: 10, maintenanceCost: 49 }
  };

  var SCORE_BANDS = [
    {
      min: 80,
      label: 'Sehr attraktiv',
      color: 'green',
      message: 'Hoher Gewinn und komfortabler Abstand zum Break-even.'
    },
    {
      min: 60,
      label: 'Attraktiv',
      color: 'light-green',
      message: 'Der Standort wirkt wirtschaftlich, die Annahmen sollten geprüft werden.'
    },
    {
      min: 40,
      label: 'Grenzwertig',
      color: 'yellow-orange',
      message: 'Der Standort kann funktionieren, braucht aber Optimierung.'
    },
    {
      min: 20,
      label: 'Kritisch',
      color: 'orange-red',
      message: 'Der Standort hat ein erhöhtes Risiko und wenig wirtschaftlichen Puffer.'
    },
    {
      min: 0,
      label: 'Nicht empfehlenswert',
      color: 'red',
      message: 'Der Standort trägt sich mit den aktuellen Annahmen voraussichtlich nicht.'
    }
  ];

  var SCENARIO_DEFS = [
    {
      label: 'Vorsichtig',
      unitMultiplier: 0.8,
      cogsMultiplier: 1.05,
      description: '20 % weniger Verkäufe und 5 % höhere Einkaufskosten'
    },
    {
      label: 'Realistisch',
      unitMultiplier: 1,
      cogsMultiplier: 1,
      description: 'Ihre aktuellen Eingaben'
    },
    {
      label: 'Optimistisch',
      unitMultiplier: 1.2,
      cogsMultiplier: 0.95,
      description: '20 % mehr Verkäufe und 5 % bessere Einkaufskosten'
    }
  ];

  var REVERSE_TARGETS = [
    { label: 'Kosten decken', targetProfitPerMonth: 0, note: 'Ab hier ist der Automat nicht mehr im Minus' },
    { label: '500 € Gewinn', targetProfitPerMonth: 500, note: 'Solider Nebenverdienst / Standortbeitrag' },
    { label: '1.000 € Gewinn', targetProfitPerMonth: 1000, note: 'Sehr attraktiver Standort' }
  ];

  function toNumber(value, fallback) {
    if (fallback === undefined) fallback = 0;
    if (typeof value === 'number') return Number.isFinite(value) ? value : fallback;
    if (typeof value !== 'string') return fallback;
    var trimmed = value.trim();
    var normalized = trimmed.indexOf(',') >= 0 ? trimmed.replace(/\./g, '').replace(',', '.') : trimmed;
    if (normalized === '') return fallback;
    var parsed = Number(normalized);
    return Number.isFinite(parsed) ? parsed : fallback;
  }

  function round(value, decimals) {
    var factor = Math.pow(10, decimals || 2);
    return Math.round((Number(value) || 0) * factor) / factor;
  }

  function clamp(value, min, max) {
    var numeric = Number.isFinite(value) ? value : 0;
    if (min !== undefined && numeric < min) return min;
    if (max !== undefined && numeric > max) return max;
    return numeric;
  }

  function percent(value) {
    return clamp(toNumber(value), 0, 100) / 100;
  }

  function safeDivide(numerator, denominator, fallback) {
    if (fallback === undefined) fallback = 0;
    return denominator ? numerator / denominator : fallback;
  }

  function moneyFormatter() {
    if (typeof Intl !== 'undefined' && Intl.NumberFormat) {
      return new Intl.NumberFormat('de-DE', {
        style: 'currency',
        currency: 'EUR',
        maximumFractionDigits: 2
      });
    }
    return {
      format: function (value) {
        return round(value, 2) + ' EUR';
      }
    };
  }

  var currency = moneyFormatter();

  function formatMoney(value) {
    if (!Number.isFinite(value)) return 'nicht erreichbar';
    return currency.format(value || 0);
  }

  function formatSignedMoney(value) {
    if (!Number.isFinite(value)) return 'nicht erreichbar';
    return (value > 0 ? '+' : '') + formatMoney(value);
  }

  function formatNumber(value, digits) {
    if (!Number.isFinite(value)) return 'nicht erreichbar';
    if (typeof Intl !== 'undefined' && Intl.NumberFormat) {
      return new Intl.NumberFormat('de-DE', {
        maximumFractionDigits: digits === undefined ? 1 : digits
      }).format(value || 0);
    }
    return String(round(value, digits === undefined ? 1 : digits));
  }

  function formatPercent(value, digits) {
    if (!Number.isFinite(value)) return 'nicht erreichbar';
    return formatNumber((value || 0) * 100, digits === undefined ? 1 : digits) + ' %';
  }

  function getScoreBand(score) {
    for (var index = 0; index < SCORE_BANDS.length; index += 1) {
      if (score >= SCORE_BANDS[index].min) return SCORE_BANDS[index];
    }
    return SCORE_BANDS[SCORE_BANDS.length - 1];
  }

  function getBreakEvenBand(result) {
    var buffer = Number.isFinite(result.safetyBuffer) ? result.safetyBuffer : -1;
    if (buffer > 0.3) {
      return { label: 'Stark', color: 'green', text: 'Komfortabler Puffer' };
    }
    if (buffer >= 0) {
      return { label: 'Knapp positiv', color: 'light-green', text: 'Standort funktioniert, aber mit wenig Reserve' };
    }
    if (buffer >= -0.2) {
      return { label: 'Kritisch', color: 'yellow-orange', text: 'Kleine Verbesserungen nötig' };
    }
    return { label: 'Schwach', color: 'red', text: 'Standort aktuell nicht wirtschaftlich' };
  }

  function getRevenueShareBaseLabel(value) {
    if (value === 'gross') return 'Brutto-Umsatz';
    if (value === 'grossProfit') return 'Rohertrag';
    return 'Netto-Umsatz';
  }

  function normalizeCategories(categories) {
    var source = Array.isArray(categories) && categories.length ? categories : DEFAULT_CATEGORIES;
    var active = source
      .map(function (category, index) {
        return {
          id: category.id || 'category-' + index,
          name: category.name || 'Kategorie',
          enabled: category.enabled !== false,
          mixShare: clamp(toNumber(category.mixShare), 0, 100),
          grossSellingPrice: clamp(toNumber(category.grossSellingPrice), 0, 9999),
          purchasePriceNet: clamp(toNumber(category.purchasePriceNet), 0, 9999),
          vatRate: clamp(toNumber(category.vatRate), 0, 100),
          wasteRate: clamp(toNumber(category.wasteRate), 0, 100),
          shrinkageRate: clamp(toNumber(category.shrinkageRate), 0, 100)
        };
      })
      .filter(function (category) {
        return category.enabled;
      });

    var mixShareSum = active.reduce(function (sum, category) {
      return sum + category.mixShare;
    }, 0);

    if (!active.length || mixShareSum <= 0) {
      active = DEFAULT_CATEGORIES.slice(0, 1);
      mixShareSum = 100;
    }

    return {
      categories: active.map(function (category) {
        var normalizedShare = category.mixShare / mixShareSum;
        return Object.assign({}, category, {
          normalizedShare: Number.isFinite(normalizedShare) ? normalizedShare : 0
        });
      }),
      mixShareSum: mixShareSum,
      wasNormalized: Math.abs(mixShareSum - 100) > 0.01
    };
  }

  function buildInput(overrides) {
    var input = overrides || {};
    return {
      location: Object.assign(
        {
          locationType: 'office',
          visitorsPerDay: 120,
          activeDaysPerMonth: 22,
          activeHoursPerDay: 8,
          accessType: 'business',
          locationQuality: 'very-high',
          conversionRate: 12,
          itemsPerTransaction: 1.75,
          manualUnitsMode: false,
          manualUnitsPerDay: 20,
          seasonalMonthsPerYear: 0,
          seasonalityFactor: 1
        },
        input.location || {}
      ),
      categories: Array.isArray(input.categories) ? input.categories : DEFAULT_CATEGORIES,
      machine: Object.assign(
        {
          acquisitionType: 'purchase',
          purchasePriceNet: 6950,
          leasingRateNet: 150,
          financingAmount: 0,
          downPayment: 0,
          annualInterestRate: 6.5,
          termMonths: 48,
          residualValue: 1000,
          deliveryCost: 250,
          installationCost: 0,
          setupCost: 0,
          depreciationMonths: 60
        },
        input.machine || {}
      ),
      costs: Object.assign(
        {
          electricityKwhPerDay: 3,
          electricityPricePerKwh: 0.35,
          fixedLocationRent: 0,
          revenueSharePercentage: 0,
          revenueShareBase: 'net',
          minimumGuarantee: 0,
          rentCap: 0,
          cardPaymentShare: 70,
          paymentFeePercentage: 1.5,
          fixedPaymentFee: 0.05,
          monthlyTerminalFee: 10,
          refillsPerMonth: 4,
          hoursPerRefill: 1,
          hourlyRate: 25,
          travelCostPerRefill: 10,
          cleaningCost: 0,
          maintenanceCost: 49,
          repairReserve: 0,
          insuranceCost: 0,
          telemetryCost: 0,
          adminCost: 0,
          storageCost: 0,
          otherMonthlyCosts: 0,
          targetMonthlyProfit: 500
        },
        input.costs || {}
      )
    };
  }

  function loanPayment(principal, annualInterestRate, termMonths) {
    principal = clamp(principal, 0);
    termMonths = Math.max(1, Math.round(clamp(termMonths, 1, 600)));
    var monthlyInterestRate = percent(annualInterestRate) / 12;
    if (principal <= 0) return 0;
    if (monthlyInterestRate <= 0) return principal / termMonths;
    return (
      (principal * monthlyInterestRate * Math.pow(1 + monthlyInterestRate, termMonths)) /
      (Math.pow(1 + monthlyInterestRate, termMonths) - 1)
    );
  }

  function getFinancing(machine) {
    var purchasePriceNet = clamp(toNumber(machine.purchasePriceNet), 0);
    var deliveryCost = clamp(toNumber(machine.deliveryCost), 0);
    var installationCost = clamp(toNumber(machine.installationCost), 0);
    var setupCost = clamp(toNumber(machine.setupCost), 0);
    var downPayment = clamp(toNumber(machine.downPayment), 0);
    var totalAcquisitionCost = purchasePriceNet + deliveryCost + installationCost + setupCost;
    var acquisitionType = machine.acquisitionType || 'purchase';
    var monthlyFinancingCost = 0;
    var initialInvestment = 0;
    var monthlyDepreciation = 0;

    if (acquisitionType === 'purchase') {
      initialInvestment = totalAcquisitionCost;
      monthlyDepreciation = safeDivide(
        Math.max(0, purchasePriceNet - clamp(toNumber(machine.residualValue), 0)),
        Math.max(1, clamp(toNumber(machine.depreciationMonths), 1))
      );
    }

    if (acquisitionType === 'leasing') {
      monthlyFinancingCost = clamp(toNumber(machine.leasingRateNet), 0);
      initialInvestment = downPayment + deliveryCost + installationCost + setupCost;
    }

    if (acquisitionType === 'financing') {
      var principal = Math.max(0, totalAcquisitionCost - downPayment);
      monthlyFinancingCost = loanPayment(principal, machine.annualInterestRate, machine.termMonths);
      initialInvestment = downPayment;
      monthlyDepreciation = safeDivide(
        Math.max(0, purchasePriceNet - clamp(toNumber(machine.residualValue), 0)),
        Math.max(1, clamp(toNumber(machine.depreciationMonths), 1))
      );
    }

    return {
      acquisitionType: acquisitionType,
      totalAcquisitionCost: totalAcquisitionCost,
      monthlyFinancingCost: monthlyFinancingCost,
      initialInvestment: initialInvestment,
      monthlyDepreciation: monthlyDepreciation
    };
  }

  function calculate(input, options) {
    var model = buildInput(input);
    var scenario = Object.assign(
      {
        name: 'Realistisch',
        unitMultiplier: 1,
        cogsMultiplier: 1
      },
      options || {}
    );
    var location = model.location;
    var costs = model.costs;
    var machine = model.machine;
    var warnings = [];
    var normalized = normalizeCategories(model.categories);
    var activeDaysPerMonth = Math.max(1, clamp(toNumber(location.activeDaysPerMonth), 1, 31));
    var itemsPerTransaction = Math.max(1, clamp(toNumber(location.itemsPerTransaction), 1, 5));
    var conversionRate = clamp(toNumber(location.conversionRate), 0, 100);
    var seasonalityFactor = Math.max(0.1, clamp(toNumber(location.seasonalityFactor), 0.1, 2));
    var seasonalMonthsPerYear = clamp(toNumber(location.seasonalMonthsPerYear), 0, 12);
    var weightedSeasonalityFactor = ((12 - seasonalMonthsPerYear) + seasonalMonthsPerYear * seasonalityFactor) / 12;
    var visitorsPerDay = Math.max(0, clamp(toNumber(location.visitorsPerDay), 0, 50000));
    var manualUnitsPerDay = Math.max(0, clamp(toNumber(location.manualUnitsPerDay), 0, 5000));

    var baseDailyUnits = location.manualUnitsMode
      ? manualUnitsPerDay
      : visitorsPerDay * (conversionRate / 100) * itemsPerTransaction;
    var dailyUnits = baseDailyUnits * scenario.unitMultiplier;
    var monthlyUnits = dailyUnits * activeDaysPerMonth * weightedSeasonalityFactor;
    var monthlyTransactions = safeDivide(monthlyUnits, itemsPerTransaction);

    var categoryResults = normalized.categories.map(function (category) {
      var units = monthlyUnits * category.normalizedShare;
      var grossRevenue = units * category.grossSellingPrice;
      var netRevenue = safeDivide(grossRevenue, 1 + category.vatRate / 100);
      var effectivePurchasedUnits = units * (1 + category.wasteRate / 100 + category.shrinkageRate / 100);
      var cogsNet = effectivePurchasedUnits * category.purchasePriceNet * scenario.cogsMultiplier;
      var grossProfit = netRevenue - cogsNet;
      return Object.assign({}, category, {
        units: units,
        grossRevenue: grossRevenue,
        netRevenue: netRevenue,
        effectivePurchasedUnits: effectivePurchasedUnits,
        cogsNet: cogsNet,
        grossProfit: grossProfit,
        grossMargin: safeDivide(grossProfit, netRevenue)
      });
    });

    var totalGrossRevenue = categoryResults.reduce(function (sum, item) {
      return sum + item.grossRevenue;
    }, 0);
    var totalNetRevenue = categoryResults.reduce(function (sum, item) {
      return sum + item.netRevenue;
    }, 0);
    var totalCogsNet = categoryResults.reduce(function (sum, item) {
      return sum + item.cogsNet;
    }, 0);
    var totalGrossProfit = totalNetRevenue - totalCogsNet;
    var weightedGrossMargin = safeDivide(totalGrossProfit, totalNetRevenue);
    var weightedNetSellingPrice = safeDivide(totalNetRevenue, monthlyUnits);
    var weightedCogsNet = safeDivide(totalCogsNet, monthlyUnits);
    var avgGrossSellingPrice = safeDivide(totalGrossRevenue, monthlyUnits);

    var cardPaymentShare = percent(costs.cardPaymentShare);
    var paymentFeePercentage = percent(costs.paymentFeePercentage);
    var fixedPaymentFee = clamp(toNumber(costs.fixedPaymentFee), 0);
    var cardTransactions = monthlyTransactions * cardPaymentShare;
    var cardRevenueGross = totalGrossRevenue * cardPaymentShare;
    var variablePaymentFees = cardRevenueGross * paymentFeePercentage + cardTransactions * fixedPaymentFee;
    var monthlyTerminalFee = clamp(toNumber(costs.monthlyTerminalFee), 0);
    var paymentFees = variablePaymentFees + monthlyTerminalFee;

    var electricityDaysPerMonth = 30;
    var electricityCost =
      clamp(toNumber(costs.electricityKwhPerDay), 0) *
      electricityDaysPerMonth *
      clamp(toNumber(costs.electricityPricePerKwh), 0);

    var fixedLocationRent = clamp(toNumber(costs.fixedLocationRent), 0);
    var revenueSharePercentage = percent(costs.revenueSharePercentage);
    var revenueShareBaseValue = totalGrossRevenue;
    if (costs.revenueShareBase === 'net') revenueShareBaseValue = totalNetRevenue;
    if (costs.revenueShareBase === 'grossProfit') revenueShareBaseValue = Math.max(0, totalGrossProfit);
    var revenueShareCost = revenueShareBaseValue * revenueSharePercentage;
    var locationRentBeforeLimits = fixedLocationRent + revenueShareCost;
    var minimumGuarantee = clamp(toNumber(costs.minimumGuarantee), 0);
    var rentCap = clamp(toNumber(costs.rentCap), 0);
    var locationRent = Math.max(locationRentBeforeLimits, minimumGuarantee);
    if (rentCap > 0) locationRent = Math.min(locationRent, rentCap);

    var refillLaborCost =
      clamp(toNumber(costs.refillsPerMonth), 0) *
      clamp(toNumber(costs.hoursPerRefill), 0) *
      clamp(toNumber(costs.hourlyRate), 0);
    var refillTravelCost = clamp(toNumber(costs.refillsPerMonth), 0) * clamp(toNumber(costs.travelCostPerRefill), 0);
    var cleaningCost = clamp(toNumber(costs.cleaningCost), 0);
    var maintenanceCost = clamp(toNumber(costs.maintenanceCost), 0);
    var repairReserve = clamp(toNumber(costs.repairReserve), 0);
    var insuranceCost = clamp(toNumber(costs.insuranceCost), 0);
    var telemetryCost = clamp(toNumber(costs.telemetryCost), 0);
    var adminCost = clamp(toNumber(costs.adminCost), 0);
    var storageCost = clamp(toNumber(costs.storageCost), 0);
    var otherMonthlyCosts = clamp(toNumber(costs.otherMonthlyCosts), 0);
    var operationalCosts =
      refillLaborCost +
      refillTravelCost +
      cleaningCost +
      maintenanceCost +
      repairReserve +
      insuranceCost +
      telemetryCost +
      adminCost +
      storageCost +
      otherMonthlyCosts;

    var financing = getFinancing(machine);
    var operatingProfitBeforeFinancing =
      totalGrossProfit - paymentFees - electricityCost - locationRent - operationalCosts;
    var monthlyCashflow = operatingProfitBeforeFinancing - financing.monthlyFinancingCost;
    var annualCashflow = monthlyCashflow * 12;
    var accountingProfit = operatingProfitBeforeFinancing - financing.monthlyDepreciation;

    var variablePaymentFeePerUnit = safeDivide(variablePaymentFees, monthlyUnits);
    var variableRentPerUnit = safeDivide(revenueShareCost, monthlyUnits);
    var avgContributionPerUnit =
      weightedNetSellingPrice - weightedCogsNet - variablePaymentFeePerUnit - variableRentPerUnit;
    var effectiveFixedRent = Math.max(0, locationRent - revenueShareCost);
    var fixedMonthlyCosts =
      electricityCost +
      effectiveFixedRent +
      monthlyTerminalFee +
      operationalCosts +
      financing.monthlyFinancingCost;
    var breakEvenUnitsPerMonth = avgContributionPerUnit > 0 ? fixedMonthlyCosts / avgContributionPerUnit : Infinity;
    var breakEvenUnitsPerDay = safeDivide(breakEvenUnitsPerMonth, activeDaysPerMonth, Infinity);
    var breakEvenGrossRevenue = breakEvenUnitsPerMonth * avgGrossSellingPrice;
    var breakEvenConversionRate = visitorsPerDay > 0 && itemsPerTransaction > 0
      ? safeDivide(breakEvenUnitsPerDay, visitorsPerDay * itemsPerTransaction)
      : Infinity;
    var safetyBuffer = Number.isFinite(breakEvenUnitsPerDay)
      ? safeDivide(dailyUnits - breakEvenUnitsPerDay, Math.max(breakEvenUnitsPerDay, 1))
      : -1;

    var initialInvestment = financing.initialInvestment;
    var paybackMonths = monthlyCashflow > 0 && initialInvestment > 0 ? initialInvestment / monthlyCashflow : Infinity;
    var annualROI = initialInvestment > 0 ? annualCashflow / initialInvestment : null;
    var targetMonthlyProfit = clamp(toNumber(costs.targetMonthlyProfit), 0);
    var operatingProfitBeforeRent =
      totalGrossProfit - paymentFees - electricityCost - operationalCosts - financing.monthlyFinancingCost;
    var maxAffordableRent = operatingProfitBeforeRent - targetMonthlyProfit;
    var maxLeasingRate = totalGrossProfit - paymentFees - electricityCost - locationRent - operationalCosts - targetMonthlyProfit;
    var requiredMonthlyUnitsForTargetProfit =
      avgContributionPerUnit > 0 ? (fixedMonthlyCosts + targetMonthlyProfit) / avgContributionPerUnit : Infinity;
    var requiredDailyUnitsForTargetProfit = safeDivide(requiredMonthlyUnitsForTargetProfit, activeDaysPerMonth, Infinity);
    var requiredVisitorsPerDay =
      conversionRate > 0 && itemsPerTransaction > 0
        ? safeDivide(requiredDailyUnitsForTargetProfit, (conversionRate / 100) * itemsPerTransaction, Infinity)
        : Infinity;
    var requiredMachinesForTargetProfit =
      monthlyCashflow > 0 && targetMonthlyProfit > 0 ? Math.ceil(targetMonthlyProfit / monthlyCashflow) : Infinity;
    var purchasePriceStressLimit =
      weightedCogsNet > 0 && monthlyUnits > 0
        ? safeDivide(
            weightedNetSellingPrice - variablePaymentFeePerUnit - variableRentPerUnit - safeDivide(fixedMonthlyCosts, monthlyUnits),
            weightedCogsNet
          )
        : Infinity;

    if (normalized.wasNormalized) {
      warnings.push('Der Produktmix wurde automatisch auf 100 % normalisiert. Eingabesumme: ' + formatNumber(normalized.mixShareSum, 1) + ' %.');
    }
    if (avgContributionPerUnit <= 0) {
      warnings.push('Mit diesen Annahmen ist kein Break-even möglich, da der Deckungsbeitrag pro verkauftem Produkt negativ oder null ist.');
    }
    if (visitorsPerDay > 0 && visitorsPerDay < 25 && !location.manualUnitsMode) {
      warnings.push('Die Besucherzahl ist sehr niedrig. Prüfen Sie, ob ein kompakter Automat oder ein anderer Standort besser passt.');
    }
    if (locationRent > totalGrossProfit && totalGrossProfit > 0) {
      warnings.push('Die Standortmiete liegt über dem Rohertrag. Das Standortmodell sollte neu verhandelt werden.');
    }
    if (financing.acquisitionType === 'leasing' && financing.monthlyFinancingCost > operatingProfitBeforeFinancing) {
      warnings.push('Die Leasingrate zehrt den operativen Gewinn auf. Prüfen Sie Laufzeit, Rate oder Kaufoption.');
    }
    if (electricityCost > totalGrossProfit * 0.25 && totalGrossProfit > 0) {
      warnings.push('Die Stromkosten wirken im Verhältnis zum Rohertrag hoch. Modell, Kühlung und Standortbedingungen prüfen.');
    }

    var locationScore = scoreLocation({
      dailyUnits: dailyUnits,
      breakEvenUnitsPerDay: breakEvenUnitsPerDay,
      monthlyCashflow: monthlyCashflow,
      totalNetRevenue: totalNetRevenue,
      targetMonthlyProfit: targetMonthlyProfit,
      weightedGrossMargin: weightedGrossMargin,
      fixedMonthlyCosts: fixedMonthlyCosts,
      totalGrossProfit: totalGrossProfit,
      paybackMonths: paybackMonths,
      initialInvestment: initialInvestment
    });

    return {
      scenarioName: scenario.name,
      input: model,
      categories: categoryResults,
      mixShareSum: normalized.mixShareSum,
      mixWasNormalized: normalized.wasNormalized,
      dailyUnits: dailyUnits,
      monthlyUnits: monthlyUnits,
      monthlyTransactions: monthlyTransactions,
      totalGrossRevenue: totalGrossRevenue,
      totalNetRevenue: totalNetRevenue,
      annualGrossRevenue: totalGrossRevenue * 12,
      annualNetRevenue: totalNetRevenue * 12,
      totalCogsNet: totalCogsNet,
      totalGrossProfit: totalGrossProfit,
      weightedGrossMargin: weightedGrossMargin,
      weightedNetSellingPrice: weightedNetSellingPrice,
      weightedCogsNet: weightedCogsNet,
      avgContributionPerUnit: avgContributionPerUnit,
      avgGrossSellingPrice: avgGrossSellingPrice,
      paymentFees: paymentFees,
      variablePaymentFees: variablePaymentFees,
      monthlyTerminalFee: monthlyTerminalFee,
      electricityCost: electricityCost,
      locationRent: locationRent,
      revenueShareCost: revenueShareCost,
      operationalCosts: operationalCosts,
      refillLaborCost: refillLaborCost,
      refillTravelCost: refillTravelCost,
      maintenanceCost: maintenanceCost,
      insuranceCost: insuranceCost,
      telemetryCost: telemetryCost,
      financingCost: financing.monthlyFinancingCost,
      financing: financing,
      fixedMonthlyCosts: fixedMonthlyCosts,
      operatingProfitBeforeFinancing: operatingProfitBeforeFinancing,
      monthlyCashflow: monthlyCashflow,
      annualCashflow: annualCashflow,
      accountingProfit: accountingProfit,
      profitPerUnit: safeDivide(monthlyCashflow, monthlyUnits),
      profitPerDay: safeDivide(monthlyCashflow, activeDaysPerMonth),
      breakEvenUnitsPerMonth: breakEvenUnitsPerMonth,
      breakEvenUnitsPerDay: breakEvenUnitsPerDay,
      breakEvenGrossRevenue: breakEvenGrossRevenue,
      breakEvenConversionRate: breakEvenConversionRate,
      safetyBuffer: safetyBuffer,
      paybackMonths: paybackMonths,
      annualROI: annualROI,
      locationScore: locationScore,
      maxAffordableRent: maxAffordableRent,
      maxLeasingRate: maxLeasingRate,
      requiredDailyUnitsForTargetProfit: requiredDailyUnitsForTargetProfit,
      requiredVisitorsPerDay: requiredVisitorsPerDay,
      requiredMachinesForTargetProfit: requiredMachinesForTargetProfit,
      purchasePriceStressLimit: purchasePriceStressLimit,
      warnings: warnings
    };
  }

  function scoreLocation(data) {
    var profitTarget = Math.max(300, toNumber(data.totalNetRevenue) * 0.15, toNumber(data.targetMonthlyProfit));
    var profitabilityScore = clamp(safeDivide(data.monthlyCashflow, profitTarget), 0, 1) * 100;
    var breakEvenBufferScore = 0;
    if (Number.isFinite(data.breakEvenUnitsPerDay) && data.breakEvenUnitsPerDay > 0) {
      breakEvenBufferScore = clamp((data.dailyUnits - data.breakEvenUnitsPerDay) / (data.breakEvenUnitsPerDay * 0.5), 0, 1) * 100;
    }
    var costLoad = data.totalGrossProfit > 0 ? clamp(data.fixedMonthlyCosts / data.totalGrossProfit, 0, 1) : 1;
    var costRiskScore = (1 - costLoad) * 100;
    return clamp(Math.round(profitabilityScore * 0.5 + breakEvenBufferScore * 0.35 + costRiskScore * 0.15), 0, 100);
  }

  function scenarioResults(input) {
    return SCENARIO_DEFS.map(function (definition) {
      return Object.assign(
        calculate(input, {
          name: definition.label,
          unitMultiplier: definition.unitMultiplier,
          cogsMultiplier: definition.cogsMultiplier
        }),
        { scenarioDescription: definition.description }
      );
    });
  }

  function getScoreLabel(score) {
    return getScoreBand(score).label;
  }

  function getRecommendation(result) {
    var locationType = result.input.location.locationType;
    var dailyUnits = result.dailyUnits;
    var size = 'kleiner Snackautomat oder kompakter Kombiautomat';
    if (dailyUnits >= 20 && dailyUnits <= 60) size = 'Standard Snack-/Kombiautomat';
    if (dailyUnits > 60) size = 'großer Automat, Doppelstandort oder mehrere Automaten';

    var assortment = 'Snacks, Getränke und schnell drehende Produkte';
    if (locationType === 'gym') assortment = 'gesunde Snacks, Proteinprodukte und kalte Getränke';
    if (locationType === 'office') assortment = 'Snacks, Getränke, Kaffee-Optionen und Mitarbeiterverpflegung';
    if (locationType === 'warehouse') assortment = 'robuste 24/7-Lösung, schnelle Produkte und kalte Getränke';

    return 'Empfehlung: Prüfen Sie ' + size + '. Für diesen Standort passen besonders ' + assortment + '.';
  }

  function getInterpretation(result) {
    var profit = formatMoney(result.monthlyCashflow);
    var breakEven = Number.isFinite(result.breakEvenUnitsPerDay)
      ? formatNumber(result.breakEvenUnitsPerDay, 1) + ' Verkäufe pro Tag'
      : 'nicht erreichbar';
    var acquisitionType = result.financing.acquisitionType;
    var financeText = '';

    if (acquisitionType === 'leasing') {
      financeText =
        ' Leasing reduziert die Anfangsinvestition, belastet aber den monatlichen Cashflow mit ' +
        formatMoney(result.financingCost) +
        '.';
    }
    if (acquisitionType === 'purchase' && Number.isFinite(result.paybackMonths)) {
      financeText =
        ' Beim Kauf liegt die geschätzte Amortisation bei rund ' +
        formatNumber(result.paybackMonths, 1) +
        ' Monaten.';
    }
    if (acquisitionType === 'financing') {
      financeText =
        ' Die Finanzierungsrate ist mit ' +
        formatMoney(result.financingCost) +
        ' pro Monat im Cashflow berücksichtigt.';
    }

    if (result.monthlyCashflow > 0 && result.safetyBuffer > 0.25) {
      return (
        'Mit Ihren Eingaben erzielt der Automat voraussichtlich ca. ' +
        profit +
        ' Gewinn pro Monat. Der Break-even liegt bei rund ' +
        breakEven +
        ', damit hat der Standort einen komfortablen Puffer.' +
        financeText
      );
    }

    if (result.monthlyCashflow > 0) {
      return (
        'Der Standort ist grundsätzlich interessant, liegt aber nah am Break-even. Schon kleine Änderungen bei Verkaufspreis, Miete oder Einkaufskonditionen können das Ergebnis stark beeinflussen.' +
        financeText
      );
    }

    return (
      'Mit den aktuellen Annahmen wäre der Automat voraussichtlich nicht profitabel. Prüfen Sie höhere Verkaufspreise, geringere Standortmiete, bessere Einkaufskonditionen oder ein anderes Automatenmodell.' +
      financeText
    );
  }

  function getBiggestLever(scenarios) {
    var realistic = scenarios[1];
    var salesSwing = Math.abs(scenarios[2].monthlyCashflow - scenarios[0].monthlyCashflow);
    var marginLow = calculate(realistic.input, { name: 'Marge niedriger', unitMultiplier: 1, cogsMultiplier: 1.1 });
    var marginHigh = calculate(realistic.input, { name: 'Marge hoeher', unitMultiplier: 1, cogsMultiplier: 0.9 });
    var marginSwing = Math.abs(marginHigh.monthlyCashflow - marginLow.monthlyCashflow);
    if (salesSwing >= marginSwing) {
      return 'Größter Hebel: tägliche Verkäufe. Besucherfrequenz, Platzierung und Sortiment haben hier den stärksten Effekt.';
    }
    return 'Größter Hebel: Marge. Einkaufskonditionen, Verkaufspreise und Schwund wirken hier besonders stark.';
  }

  function readCategoryInputs(section) {
    return Array.prototype.map.call(section.querySelectorAll('[data-roi-category]'), function (category, index) {
      var data = { id: 'category-' + index };
      Array.prototype.forEach.call(category.querySelectorAll('[data-cat-field]'), function (field) {
        var key = field.getAttribute('data-cat-field');
        data[key] = field.type === 'checkbox' ? field.checked : field.value;
      });
      return data;
    });
  }

  function readCalculatorInput(section) {
    var fields = {};
    Array.prototype.forEach.call(section.querySelectorAll('[data-roi-field]'), function (field) {
      if (field.disabled && field.type !== 'hidden' && field.type !== 'checkbox') return;
      var key = field.getAttribute('data-roi-field');
      if (field.type === 'checkbox') {
        fields[key] = field.checked;
      } else {
        fields[key] = field.value;
      }
    });

    var categories = readCategoryInputs(section);

    var locationCostModel = fields.locationCostModel || 'none';
    var fixedLocationRent = toNumber(fields.fixedLocationRent);
    var revenueSharePercentage = toNumber(fields.revenueSharePercentage);
    if (locationCostModel === 'none' || locationCostModel === 'unknown') {
      fixedLocationRent = 0;
      revenueSharePercentage = 0;
    }
    if (locationCostModel === 'fixed') revenueSharePercentage = 0;
    if (locationCostModel === 'share') fixedLocationRent = 0;

    return buildInput({
      location: {
        locationType: fields.locationType,
        visitorsPerDay: toNumber(fields.visitorsPerDay),
        activeDaysPerMonth: toNumber(fields.activeDaysPerMonth, 22),
        activeHoursPerDay: toNumber(fields.activeHoursPerDay, 8),
        accessType: fields.accessType,
        locationQuality: fields.locationQuality,
        conversionRate: toNumber(fields.conversionRate, QUALITY_RATES[fields.locationQuality] || 6),
        itemsPerTransaction: toNumber(fields.itemsPerTransaction, 1.2),
        manualUnitsMode: Boolean(fields.manualUnitsMode),
        manualUnitsPerDay: toNumber(fields.manualUnitsPerDay, 20),
        seasonalMonthsPerYear: toNumber(fields.seasonalMonthsPerYear, 0),
        seasonalityFactor: toNumber(fields.seasonalityFactor, 1)
      },
      categories: categories.length ? categories : DEFAULT_CATEGORIES,
      machine: {
        acquisitionType: fields.acquisitionType,
        purchasePriceNet: toNumber(fields.purchasePriceNet),
        leasingRateNet: toNumber(fields.leasingRateNet),
        downPayment: toNumber(fields.downPayment),
        annualInterestRate: toNumber(fields.annualInterestRate),
        termMonths: toNumber(fields.termMonths),
        residualValue: toNumber(fields.residualValue),
        deliveryCost: toNumber(fields.deliveryCost),
        installationCost: toNumber(fields.installationCost),
        setupCost: toNumber(fields.setupCost),
        depreciationMonths: toNumber(fields.depreciationMonths)
      },
      costs: {
        electricityKwhPerDay: toNumber(fields.electricityKwhPerDay),
        electricityPricePerKwh: toNumber(fields.electricityPricePerKwh),
        fixedLocationRent: fixedLocationRent,
        revenueSharePercentage: revenueSharePercentage,
        revenueShareBase: fields.revenueShareBase,
        minimumGuarantee: toNumber(fields.minimumGuarantee),
        rentCap: toNumber(fields.rentCap),
        cardPaymentShare: toNumber(fields.cardPaymentShare),
        paymentFeePercentage: toNumber(fields.paymentFeePercentage),
        fixedPaymentFee: toNumber(fields.fixedPaymentFee),
        monthlyTerminalFee: toNumber(fields.monthlyTerminalFee),
        refillsPerMonth: toNumber(fields.refillsPerMonth),
        hoursPerRefill: toNumber(fields.hoursPerRefill),
        hourlyRate: toNumber(fields.hourlyRate),
        travelCostPerRefill: toNumber(fields.travelCostPerRefill),
        cleaningCost: toNumber(fields.cleaningCost),
        maintenanceCost: toNumber(fields.maintenanceCost),
        repairReserve: toNumber(fields.repairReserve),
        insuranceCost: toNumber(fields.insuranceCost),
        telemetryCost: toNumber(fields.telemetryCost),
        adminCost: toNumber(fields.adminCost),
        storageCost: toNumber(fields.storageCost),
        otherMonthlyCosts: toNumber(fields.otherMonthlyCosts),
        targetMonthlyProfit: toNumber(fields.targetMonthlyProfit)
      }
    });
  }

  function renderResultCards(section, result) {
    var target = section.querySelector('[data-roi-result-cards]');
    if (!target) return;
    var breakEven = Number.isFinite(result.breakEvenUnitsPerDay)
      ? formatNumber(result.breakEvenUnitsPerDay, 1) + ' Verkäufe / Tag'
      : 'nicht erreichbar';
    var cards = [
      [
        'Monatsgewinn',
        formatMoney(result.monthlyCashflow),
        'Gewinn nach Ware, Standort, Payment, Strom, Betrieb und Finanzierung'
      ],
      [
        'Umsatz / Monat',
        formatMoney(result.totalGrossRevenue),
        'Erwarteter Brutto-Umsatz. Netto: ' + formatMoney(result.totalNetRevenue)
      ],
      [
        'Verkäufe / Tag',
        formatNumber(result.dailyUnits, 1),
        'Geschätzte täglich verkaufte Artikel auf Basis Ihrer Eingaben'
      ],
      [
        'Break-even',
        breakEven,
        'Ab dieser Verkaufsmenge deckt der Automat seine laufenden Kosten'
      ]
    ];
    target.innerHTML = cards
      .map(function (card) {
        return (
          '<article class="snack-roi__result-card">' +
          '<span>' +
          escapeHtml(card[0]) +
          '</span><strong>' +
          escapeHtml(card[1]) +
          '</strong><small>' +
          escapeHtml(card[2]) +
          '</small></article>'
        );
      })
      .join('');
  }

  function renderWarnings(section, result) {
    var warningTarget = section.querySelector('[data-roi-warnings]');
    var mixAlert = section.querySelector('[data-roi-mix-alert]');
    if (mixAlert) {
      mixAlert.textContent = result.mixWasNormalized
        ? 'Produktmix auf 100 % normalisiert. Eingabesumme: ' + formatNumber(result.mixShareSum, 1) + ' %.'
        : 'Produktmix: 100 % oder passend normalisiert.';
    }
    if (!warningTarget) return;
    if (!result.warnings.length) {
      warningTarget.innerHTML = '';
      return;
    }
    warningTarget.innerHTML =
      '<ul>' +
      result.warnings
        .map(function (warning) {
          return '<li>' + escapeHtml(warning) + '</li>';
        })
        .join('') +
      '</ul>';
  }

  function applyAssortmentProfile(section, profileName) {
    var profile = ASSORTMENT_PROFILES[profileName] || ASSORTMENT_PROFILES['Klassischer Snackmix'];
    Array.prototype.forEach.call(section.querySelectorAll('[data-roi-category]'), function (row) {
      var nameField = row.querySelector('[data-cat-field="name"]');
      var categoryName = nameField ? nameField.value : '';
      var values = profile[categoryName];
      if (!values) return;
      var enabled = row.querySelector('[data-cat-field="enabled"]');
      var mixShare = row.querySelector('[data-cat-field="mixShare"]');
      var grossSellingPrice = row.querySelector('[data-cat-field="grossSellingPrice"]');
      var purchasePriceNet = row.querySelector('[data-cat-field="purchasePriceNet"]');
      var vatRate = row.querySelector('[data-cat-field="vatRate"]');
      var wasteRate = row.querySelector('[data-cat-field="wasteRate"]');
      var shrinkageRate = row.querySelector('[data-cat-field="shrinkageRate"]');
      if (enabled) enabled.checked = values.share > 0;
      if (mixShare) mixShare.value = values.share;
      if (grossSellingPrice) grossSellingPrice.value = values.grossPrice;
      if (purchasePriceNet) purchasePriceNet.value = values.netCost;
      if (vatRate) vatRate.value = values.vat;
      if (wasteRate) wasteRate.value = values.waste;
      if (shrinkageRate) shrinkageRate.value = 0;
    });
  }

  function syncAssortmentProfile(event) {
    var field = event.target;
    if (!field || !field.hasAttribute('data-roi-assortment-profile')) return;
    var section = field.closest('[data-snack-roi-calculator]');
    applyAssortmentProfile(section, field.value);
  }

  function setRoiFieldValue(root, fieldName, value) {
    var field = root && root.querySelector('[data-roi-field="' + fieldName + '"]');
    if (!field) return;
    field.value = value;
  }

  function applyFieldDefaults(root, defaults) {
    Object.keys(defaults || {}).forEach(function (fieldName) {
      setRoiFieldValue(root, fieldName, defaults[fieldName]);
    });
  }

  function applyAcquisitionDefaults(section, acquisitionType) {
    if (!section || !ACQUISITION_DEFAULTS[acquisitionType]) return;
    var panel = section.querySelector('[data-roi-acquisition-panel="' + acquisitionType + '"]') || section;
    applyFieldDefaults(panel, ACQUISITION_DEFAULTS[acquisitionType]);
  }

  function applyLocationCostDefaults(section, model) {
    applyFieldDefaults(section, LOCATION_COST_DEFAULTS[model] || LOCATION_COST_DEFAULTS.none);
  }

  function applyPaymentProfile(section, profileName) {
    applyFieldDefaults(section, PAYMENT_PROFILES[profileName] || PAYMENT_PROFILES.mixed);
  }

  function applyOperationProfile(section, profileName) {
    applyFieldDefaults(section, OPERATION_PROFILES[profileName] || OPERATION_PROFILES.self);
  }

  function syncCostDefaults(event) {
    var field = event.target;
    if (!field) return;
    var section = field.closest('[data-snack-roi-calculator]');
    if (!section) return;
    if (field.getAttribute('data-roi-field') === 'acquisitionType') {
      applyAcquisitionDefaults(section, field.value);
    }
    if (field.getAttribute('data-roi-field') === 'locationCostModel') {
      applyLocationCostDefaults(section, field.value);
    }
    if (field.hasAttribute('data-roi-payment-profile')) {
      applyPaymentProfile(section, field.value);
    }
    if (field.hasAttribute('data-roi-operation-profile')) {
      applyOperationProfile(section, field.value);
    }
  }

  function renderAssortmentSummary(section) {
    var target = section.querySelector('[data-roi-assortment-summary]');
    if (!target) return;
    var categories = readCategoryInputs(section);
    target.innerHTML = categories
      .map(function (category) {
        var enabled = category.enabled !== false && toNumber(category.mixShare) > 0;
        return (
          '<tr class="' +
          (enabled ? '' : 'is-inactive') +
          '"><td>' +
          escapeHtml(category.name) +
          '</td><td>' +
          formatNumber(toNumber(category.mixShare), 1) +
          ' %</td><td>' +
          formatMoney(toNumber(category.grossSellingPrice)) +
          '</td><td>' +
          formatMoney(toNumber(category.purchasePriceNet)) +
          '</td><td>' +
          formatNumber(toNumber(category.vatRate), 0) +
          ' %</td><td>' +
          formatNumber(toNumber(category.wasteRate), 1) +
          ' %</td></tr>'
        );
      })
      .join('');
  }

  function renderAssortmentKpis(section, result) {
    var target = section.querySelector('[data-roi-assortment-kpis]');
    if (!target) return;
    var grossPrice = result.avgGrossSellingPrice;
    var netCost = result.weightedCogsNet;
    var contribution = safeDivide(result.totalGrossProfit, result.monthlyUnits);
    var items = [
      ['Ø Verkaufspreis brutto', formatMoney(grossPrice), 'gewichteter Durchschnitt aller aktiven Kategorien'],
      ['Ø Einkaufspreis netto', formatMoney(netCost), 'inkl. Schwund-Reserve je Verkauf'],
      ['Ø Rohertrag pro Verkauf', formatMoney(contribution), 'vor Standort-, Payment- und Betriebskosten']
    ];
    target.innerHTML = items
      .map(function (item) {
        return (
          '<article><span>' +
          escapeHtml(item[0]) +
          '</span><strong>' +
          escapeHtml(item[1]) +
          '</strong><small>' +
          escapeHtml(item[2]) +
          '</small></article>'
        );
      })
      .join('');
  }

  function renderSummaryBlock(target, title, rows, note) {
    if (!target) return;
    var body = rows && rows.length
      ? '<dl>' +
        rows
          .map(function (row) {
            return '<div><dt>' + escapeHtml(row[0]) + '</dt><dd>' + escapeHtml(row[1]) + '</dd></div>';
          })
          .join('') +
        '</dl>'
      : '';
    target.innerHTML =
      '<strong>' +
      escapeHtml(title) +
      '</strong>' +
      body +
      (note ? '<small>' + escapeHtml(note) + '</small>' : '');
  }

  function renderCostSummaries(section, result) {
    var input = result.input;
    var machine = input.machine;
    var costs = input.costs;
    var machineTarget = section.querySelector('[data-roi-cost-summary="machine"]');
    if (machine.acquisitionType === 'leasing') {
      renderSummaryBlock(machineTarget, 'Leasing mit planbarer Monatsrate', [
        ['Rate', formatMoney(machine.leasingRateNet) + ' / Monat'],
        ['Laufzeit', formatNumber(machine.termMonths, 0) + ' Monate'],
        ['Einmalig', formatMoney(result.financing.initialInvestment)]
      ]);
    } else if (machine.acquisitionType === 'owned') {
      renderSummaryBlock(machineTarget, 'Vorhandener Automat: 0 € Anschaffungskosten', [], 'Es werden keine Kauf- oder Leasingkosten angesetzt.');
    } else {
      renderSummaryBlock(machineTarget, 'Kauf mit Amortisationsbetrachtung', [
        ['Automat', formatMoney(machine.purchasePriceNet)],
        ['Lieferung', formatMoney(machine.deliveryCost)],
        ['Weitere Einrichtung', formatMoney(machine.installationCost + machine.setupCost)],
        ['Gesamt', formatMoney(result.financing.initialInvestment)]
      ]);
    }

    var locationModelField = section.querySelector('[data-roi-field="locationCostModel"]');
    var locationModel = locationModelField ? locationModelField.value : 'none';
    var locationTitle = 'Keine Standortkosten angesetzt';
    var locationNote = '';
    if (locationModel === 'unknown') {
      locationTitle = 'Standortkosten noch unklar: aktuell mit 0 € gerechnet';
      locationNote = 'Sobald ein Standortangebot vorliegt, können Miete oder Umsatzbeteiligung ergänzt werden.';
    } else if (locationModel !== 'none') {
      locationTitle = 'Standortkosten geschätzt: ' + formatMoney(result.locationRent) + ' / Monat';
    }
    renderSummaryBlock(section.querySelector('[data-roi-cost-summary="location"]'), locationTitle, [
      ['Fixmiete', formatMoney(costs.fixedLocationRent)],
      ['Umsatzbeteiligung', formatNumber(costs.revenueSharePercentage, 1) + ' % auf ' + getRevenueShareBaseLabel(costs.revenueShareBase)]
    ], locationNote);

    renderSummaryBlock(section.querySelector('[data-roi-cost-summary="payment"]'), 'Zahlungskosten geschätzt: ' + formatMoney(result.paymentFees) + ' / Monat', [
      ['Kartenanteil', formatNumber(costs.cardPaymentShare, 0) + ' %'],
      ['Gebührenmodell', formatNumber(costs.paymentFeePercentage, 1) + ' % + ' + formatMoney(costs.fixedPaymentFee) + ' je Kartenzahlung'],
      ['Terminalkosten', formatMoney(costs.monthlyTerminalFee) + ' / Monat']
    ]);

    renderSummaryBlock(section.querySelector('[data-roi-cost-summary="electricity"]'), 'Stromkosten geschätzt: ' + formatMoney(result.electricityCost) + ' / Monat', [
      ['Verbrauch', formatNumber(costs.electricityKwhPerDay, 1) + ' kWh / Tag'],
      ['Strompreis', formatMoney(costs.electricityPricePerKwh) + ' / kWh'],
      ['Kalkulation', '30 Tage / Monat']
    ]);

    var laborCost = costs.refillsPerMonth * costs.hoursPerRefill * costs.hourlyRate;
    var travelCost = costs.refillsPerMonth * costs.travelCostPerRefill;
    var runningCosts =
      costs.cleaningCost +
      costs.maintenanceCost +
      costs.repairReserve +
      costs.insuranceCost +
      costs.telemetryCost +
      costs.adminCost +
      costs.storageCost +
      costs.otherMonthlyCosts;
    renderSummaryBlock(section.querySelector('[data-roi-cost-summary="operation"]'), 'Betriebskosten geschätzt: ' + formatMoney(result.operationalCosts) + ' / Monat', [
      ['Befüllung', formatNumber(costs.refillsPerMonth, 0) + 'x / Monat'],
      ['Zeitkosten', formatMoney(laborCost)],
      ['Fahrtkosten', formatMoney(travelCost)],
      ['Laufende Pauschale', formatMoney(runningCosts)]
    ]);
  }

  function renderBreakEven(section, result) {
    var target = section.querySelector('[data-roi-break-even]');
    if (!target) return;
    var band = getBreakEvenBand(result);
    if (!Number.isFinite(result.breakEvenUnitsPerDay)) {
      target.innerHTML =
        '<div class="snack-roi__status-pill is-red">Break-even nicht erreichbar</div>' +
        '<h3>Break-even nicht erreichbar</h3>' +
        '<p>Mit diesen Annahmen deckt der Automat seine laufenden Kosten nicht. Prüfen Sie Marge, Miete und erwartete Verkäufe.</p>';
      return;
    }
    var distance = result.dailyUnits - result.breakEvenUnitsPerDay;
    var distanceText =
      distance >= 0
        ? 'Ihre Schätzung liegt ' + formatNumber(distance, 1) + ' Verkäufe pro Tag über dem Break-even.'
        : 'Ihre Schätzung liegt ' + formatNumber(Math.abs(distance), 1) + ' Verkäufe pro Tag unter dem Break-even.';
    target.innerHTML =
      '<div class="snack-roi__status-pill is-' +
      escapeHtml(band.color) +
      '">' +
      escapeHtml(band.label) +
      '</div><h3>Break-even: ' +
      escapeHtml(formatNumber(result.breakEvenUnitsPerDay, 1)) +
      ' Verkäufe pro Tag</h3><p>Ab ca. ' +
      escapeHtml(formatNumber(result.breakEvenUnitsPerDay, 1)) +
      ' Verkäufen pro Tag deckt der Automat alle laufenden Kosten. Jeder zusätzliche Verkauf trägt zum Gewinn bei.</p><p><strong>' +
      escapeHtml(distanceText) +
      '</strong> ' +
      escapeHtml(band.text) +
      '.</p>';
  }

  function renderScoreCard(section, result) {
    var target = section.querySelector('[data-roi-score-card]');
    if (!target) return;
    var band = getScoreBand(result.locationScore);
    target.innerHTML =
      '<div class="snack-roi__score-panel is-' +
      escapeHtml(band.color) +
      '"><div><span>Standort-Score</span><strong>' +
      escapeHtml(result.locationScore + ' / 100 - ' + band.label) +
      '</strong><p>' +
      escapeHtml(band.message) +
      '</p><small>Der Score bewertet Gewinn, Abstand zum Break-even und Kostenrisiko.</small></div><div class="snack-roi__score-meter" aria-hidden="true"><i style="width:' +
      result.locationScore +
      '%"></i></div></div>';
  }

  function getScenarioAssessment(scenario) {
    if (scenario.monthlyCashflow >= scenario.input.costs.targetMonthlyProfit && scenario.safetyBuffer > 0.3) {
      return 'Sehr gutes Szenario';
    }
    if (scenario.monthlyCashflow > 0 && scenario.safetyBuffer >= 0) {
      return 'Funktioniert, aber mit wenig Puffer';
    }
    if (scenario.monthlyCashflow > 0) {
      return 'Positiv, aber nah an der Grenze';
    }
    return 'Unter diesen Annahmen nicht wirtschaftlich';
  }

  function getScenarioRecommendation(scenarios) {
    var cautious = scenarios[0];
    var realistic = scenarios[1];
    if (cautious.monthlyCashflow > 0) {
      return 'Der Standort ist robust, wenn auch das vorsichtige Szenario noch positiv bleibt.';
    }
    if (realistic.monthlyCashflow > 0) {
      return 'Der Standort funktioniert in der realistischen Schätzung, hat aber wenig Reserve. Prüfen Sie Miete, Einkaufspreise oder erwartete Verkäufe.';
    }
    return 'Der Standort ist abhängig von optimistischen Annahmen. Prüfen Sie Miete, Einkaufspreise oder erwartete Verkäufe.';
  }

  function getRequiredTarget(result, targetProfitPerMonth) {
    var requiredMonthlyUnits =
      result.avgContributionPerUnit > 0 ? (result.fixedMonthlyCosts + targetProfitPerMonth) / result.avgContributionPerUnit : Infinity;
    var requiredDailyUnits = safeDivide(requiredMonthlyUnits, result.input.location.activeDaysPerMonth, Infinity);
    var requiredGrossRevenue = requiredMonthlyUnits * result.avgGrossSellingPrice;
    return {
      dailyUnits: requiredDailyUnits,
      grossRevenue: requiredGrossRevenue,
      distance: result.dailyUnits - requiredDailyUnits
    };
  }

  function renderScenarios(section, input) {
    var table = section.querySelector('[data-roi-scenarios] tbody');
    if (!table) return;
    var scenarios = scenarioResults(input);
    table.innerHTML = scenarios
      .map(function (scenario) {
        return (
          '<tr' +
          (scenario.scenarioName === 'Realistisch' ? ' class="is-realistic"' : '') +
          '><th>' +
          escapeHtml(scenario.scenarioName) +
          '</th><td>' +
          escapeHtml(scenario.scenarioDescription) +
          '</td><td>' +
          formatNumber(scenario.dailyUnits, 1) +
          '</td><td>' +
          formatMoney(scenario.monthlyCashflow) +
          '</td><td>' +
          escapeHtml(getScenarioAssessment(scenario)) +
          '</td></tr>'
        );
      })
      .join('');
    var lever = section.querySelector('[data-roi-lever]');
    if (lever) lever.textContent = getScenarioRecommendation(scenarios);
  }

  function renderReverse(section, result) {
    var target = section.querySelector('[data-roi-reverse]');
    if (!target) return;
    target.innerHTML = REVERSE_TARGETS.map(function (reverseTarget) {
      var required = getRequiredTarget(result, reverseTarget.targetProfitPerMonth);
      var isEnough = Number.isFinite(required.distance) && required.distance >= 0;
      var distanceText = Number.isFinite(required.distance)
        ? (isEnough ? '+' : '-') + formatNumber(Math.abs(required.distance), 1) + ' Verkäufe / Tag'
        : 'Mit aktueller Marge nicht erreichbar';
      return (
        '<article class="snack-roi__target-card ' +
        (isEnough ? 'is-met' : 'is-missing') +
        '"><div class="snack-roi__target-card-head"><strong>' +
        escapeHtml(reverseTarget.label) +
        '</strong><span>' +
        escapeHtml(Number.isFinite(required.dailyUnits) ? formatNumber(required.dailyUnits, 1) + ' Verkäufe / Tag' : 'nicht erreichbar') +
        '</span></div><p class="snack-roi__target-card-note">' +
        escapeHtml(reverseTarget.note) +
        '</p><dl><div><dt>Benötigter Umsatz</dt><dd>' +
        escapeHtml(Number.isFinite(required.grossRevenue) ? formatMoney(required.grossRevenue) + ' / Monat' : 'nicht erreichbar') +
        '</dd></div><div><dt>Aktuelle Schätzung</dt><dd>' +
        escapeHtml(formatNumber(result.dailyUnits, 1)) +
        ' Verkäufe / Tag</dd></div><div><dt>' +
        (isEnough ? 'Puffer' : 'Fehlt') +
        '</dt><dd>' +
        escapeHtml(distanceText) +
        '</dd></div></dl></article>'
      );
    }).join('');
    var comparison = section.querySelector('[data-roi-reverse-summary]');
    if (comparison) {
      var breakEvenDistance = Number.isFinite(result.breakEvenUnitsPerDay) ? result.dailyUnits - result.breakEvenUnitsPerDay : Infinity;
      comparison.textContent = Number.isFinite(breakEvenDistance)
        ? breakEvenDistance >= 0
          ? 'Ihre aktuelle Schätzung liegt über dem Break-even.'
          : 'Damit fehlen ca. ' + formatNumber(Math.abs(breakEvenDistance), 1) + ' Verkäufe pro Tag bis zur Kostendeckung.'
        : 'Mit der aktuellen Marge ist keine belastbare Zielmenge berechenbar.';
    }
  }

  function getWaterfallRows(result) {
    var baseCogs = result.categories.reduce(function (sum, category) {
      return sum + category.units * category.purchasePriceNet;
    }, 0);
    var wasteCost = Math.max(0, result.totalCogsNet - baseCogs);
    var refillCost = result.refillLaborCost + result.refillTravelCost;
    var runningCost = Math.max(0, result.operationalCosts - refillCost);
    return [
      ['Netto-Umsatz', result.totalNetRevenue, 'positive'],
      ['Wareneinsatz', -baseCogs, 'negative'],
      ['Schwund / Bruch', -wasteCost, 'negative'],
      ['Standortkosten', -result.locationRent, 'negative'],
      ['Payment-Gebühren', -result.paymentFees, 'negative'],
      ['Strom', -result.electricityCost, 'negative'],
      ['Befüllung / Arbeitszeit', -refillCost, 'negative'],
      ['Wartung / Software / Versicherung', -runningCost, 'negative'],
      ['Finanzierung / Leasing', -result.financingCost, 'negative']
    ].filter(function (row) {
      return row[0] === 'Netto-Umsatz' || Math.abs(row[1]) > 0.009;
    });
  }

  function renderWaterfall(section, result) {
    var target = section.querySelector('[data-roi-waterfall]');
    if (!target) return;
    var rows = getWaterfallRows(result);
    var max = rows.reduce(function (largest, row) {
      return Math.max(largest, Math.abs(row[1]));
    }, 1);
    target.innerHTML =
      '<div class="snack-roi__waterfall">' +
      rows
        .map(function (row) {
          var width = clamp((Math.abs(row[1]) / max) * 100, 3, 100);
          return (
            '<div class="snack-roi__bar-row"><span>' +
            escapeHtml(row[0]) +
            '</span><div><i class="is-' +
            row[2] +
            '" style="width:' +
            width +
            '%"></i></div><strong>' +
            escapeHtml(formatSignedMoney(row[1])) +
            '</strong></div>'
          );
        })
        .join('') +
      '</div>';
  }

  function updateSummary(section, result) {
    var profit = section.querySelector('[data-roi-summary-profit]');
    var text = section.querySelector('[data-roi-summary-text]');
    var score = section.querySelector('[data-roi-score] span');
    if (profit) profit.textContent = formatMoney(result.monthlyCashflow);
    if (text) text.textContent = getScoreLabel(result.locationScore);
    if (score) score.style.width = result.locationScore + '%';
  }

  function getSelectedOptionText(section, selector, fallback) {
    var field = section.querySelector(selector);
    if (!field) return fallback || '';
    var option = field.options && field.options[field.selectedIndex];
    return option ? option.text : field.value || fallback || '';
  }

  function formatFiniteNumber(value, digits, fallback) {
    return Number.isFinite(value) ? formatNumber(value, digits) : fallback || 'nicht berechenbar';
  }

  function buildLeadReport(section, result) {
    var input = result.input;
    var location = input.location;
    var machine = input.machine;
    var costs = input.costs;
    var acquisitionLabel = getSelectedOptionText(section, '[data-roi-field="acquisitionType"]', machine.acquisitionType);
    var locationTypeLabel = getSelectedOptionText(section, '[data-roi-field="locationType"]', location.locationType);
    var qualityLabel = getSelectedOptionText(section, '[data-roi-field="locationQuality"]', location.locationQuality);
    var assortmentProfile = getSelectedOptionText(section, '[data-roi-assortment-profile]', 'Nicht angegeben');
    var paymentProfile = getSelectedOptionText(section, '[data-roi-payment-profile]', 'Nicht angegeben');
    var operationProfile = getSelectedOptionText(section, '[data-roi-operation-profile]', 'Nicht angegeben');
    var locationCostModel = getSelectedOptionText(section, '[data-roi-field="locationCostModel"]', 'Nicht angegeben');
    var timestamp = '';
    try {
      timestamp = new Date().toLocaleString('de-DE');
    } catch (error) {
      timestamp = '';
    }

    var lines = [
      'Snackautomat Rentabilitaetsrechner - kompletter Rechnerbericht',
      timestamp ? 'Erstellt am: ' + timestamp : '',
      '',
      'ERGEBNIS',
      'Monatsgewinn: ' + formatMoney(result.monthlyCashflow),
      'Umsatz brutto / Monat: ' + formatMoney(result.totalGrossRevenue),
      'Umsatz netto / Monat: ' + formatMoney(result.totalNetRevenue),
      'Rohertrag / Monat: ' + formatMoney(result.totalGrossProfit),
      'Verkaeufe / Tag: ' + formatNumber(result.dailyUnits, 1),
      'Verkaeufe / Monat: ' + formatNumber(result.monthlyUnits, 1),
      'Break-even: ' + formatFiniteNumber(result.breakEvenUnitsPerDay, 1) + ' Verkaeufe / Tag',
      'Amortisation: ' + formatFiniteNumber(result.paybackMonths, 1) + ' Monate',
      'ROI p.a.: ' + (result.annualROI === null ? 'nicht berechenbar' : formatPercent(result.annualROI, 1)),
      'Standort-Score: ' + result.locationScore + ' / 100 - ' + getScoreLabel(result.locationScore),
      'Empfehlung: ' + getRecommendation(result),
      '',
      'STANDORT',
      'Standorttyp: ' + locationTypeLabel,
      'Aktive Tage / Monat: ' + formatNumber(location.activeDaysPerMonth, 0),
      'Aktive Stunden / Tag: ' + formatNumber(location.activeHoursPerDay, 1),
      'Potenzielle Nutzer / Tag: ' + formatNumber(location.visitorsPerDay, 0),
      'Standortqualitaet: ' + qualityLabel,
      'Kaufquote: ' + formatNumber(location.conversionRate, 1) + ' %',
      'Artikel pro Kauf: ' + formatNumber(location.itemsPerTransaction, 2),
      'Direktmodus: ' + (location.manualUnitsMode ? 'Ja, ' + formatNumber(location.manualUnitsPerDay, 1) + ' Verkaeufe / Tag' : 'Nein, automatische Verkaufsschaetzung'),
      'Saisonale Monate / Jahr: ' + formatNumber(location.seasonalMonthsPerYear, 0),
      'Saisonalitaetsfaktor: ' + formatNumber(location.seasonalityFactor, 2),
      '',
      'SORTIMENT',
      'Sortimentsprofil: ' + assortmentProfile,
      'Durchschnittlicher Verkaufspreis brutto: ' + formatMoney(result.avgGrossSellingPrice),
      'Durchschnittlicher Einkaufspreis netto: ' + formatMoney(result.weightedCogsNet),
      'Deckungsbeitrag vor Fixkosten: ' + formatMoney(result.avgContributionPerUnit)
    ];

    result.input.categories.forEach(function (category) {
      lines.push(
        '- ' +
          category.name +
          ': ' +
          (category.enabled ? 'aktiv' : 'inaktiv') +
          ', Anteil ' +
          formatNumber(toNumber(category.mixShare), 1) +
          ' %, VK brutto ' +
          formatMoney(toNumber(category.grossSellingPrice)) +
          ', EK netto ' +
          formatMoney(toNumber(category.purchasePriceNet)) +
          ', USt. ' +
          formatNumber(toNumber(category.vatRate), 0) +
          ' %, Schwund ' +
          formatNumber(toNumber(category.wasteRate), 1) +
          ' %'
      );
    });

    lines.push(
      '',
      'KOSTEN UND FINANZIERUNG',
      'Anschaffung: ' + acquisitionLabel,
      'Kaufpreis netto: ' + formatMoney(machine.purchasePriceNet),
      'Lieferung / Transport: ' + formatMoney(machine.deliveryCost),
      'Installation: ' + formatMoney(machine.installationCost),
      'Weitere Einrichtung: ' + formatMoney(machine.setupCost),
      'Leasingrate netto / Monat: ' + formatMoney(machine.leasingRateNet),
      'Leasinglaufzeit: ' + formatNumber(machine.termMonths, 0) + ' Monate',
      'Anzahlung Leasing: ' + formatMoney(machine.downPayment),
      'Einmalige Investition: ' + formatMoney(result.financing.initialInvestment),
      'Finanzierungskosten / Monat: ' + formatMoney(result.financingCost),
      '',
      'STANDORTKOSTEN',
      'Modell: ' + locationCostModel,
      'Fixmiete: ' + formatMoney(costs.fixedLocationRent),
      'Umsatzbeteiligung: ' + formatNumber(costs.revenueSharePercentage, 1) + ' %',
      'Mindestgarantie: ' + formatMoney(costs.minimumGuarantee),
      'Deckelung: ' + formatMoney(costs.rentCap),
      'Standortkosten / Monat: ' + formatMoney(result.locationRent),
      '',
      'ZAHLUNG UND STROM',
      'Zahlungsprofil: ' + paymentProfile,
      'Kartenanteil: ' + formatNumber(costs.cardPaymentShare, 0) + ' %',
      'Payment-Gebuehr: ' + formatNumber(costs.paymentFeePercentage, 1) + ' % + ' + formatMoney(costs.fixedPaymentFee) + ' je Kartenzahlung',
      'Terminalgebuehr: ' + formatMoney(costs.monthlyTerminalFee) + ' / Monat',
      'Paymentkosten / Monat: ' + formatMoney(result.paymentFees),
      'Stromverbrauch: ' + formatNumber(costs.electricityKwhPerDay, 1) + ' kWh / Tag',
      'Strompreis: ' + formatMoney(costs.electricityPricePerKwh) + ' / kWh',
      'Stromkosten / Monat: ' + formatMoney(result.electricityCost),
      '',
      'BETRIEB',
      'Betriebsprofil: ' + operationProfile,
      'Befuellungen / Monat: ' + formatNumber(costs.refillsPerMonth, 0),
      'Aufwand je Befuellung: ' + formatNumber(costs.hoursPerRefill, 2) + ' Stunden',
      'Interner Stundensatz: ' + formatMoney(costs.hourlyRate),
      'Fahrtkosten je Befuellung: ' + formatMoney(costs.travelCostPerRefill),
      'Reinigung: ' + formatMoney(costs.cleaningCost),
      'Wartung / Software: ' + formatMoney(costs.maintenanceCost),
      'Reparaturruecklage: ' + formatMoney(costs.repairReserve),
      'Versicherung: ' + formatMoney(costs.insuranceCost),
      'Telemetrie: ' + formatMoney(costs.telemetryCost),
      'Verwaltung: ' + formatMoney(costs.adminCost),
      'Lagerkosten: ' + formatMoney(costs.storageCost),
      'Sonstige Kosten: ' + formatMoney(costs.otherMonthlyCosts),
      'Betriebskosten / Monat: ' + formatMoney(result.operationalCosts),
      '',
      'SZENARIEN'
    );

    scenarioResults(input).forEach(function (scenario) {
      lines.push(
        '- ' +
          scenario.scenarioName +
          ': ' +
          scenario.scenarioDescription +
          ', ' +
          formatNumber(scenario.dailyUnits, 1) +
          ' Verkaeufe / Tag, ' +
          formatMoney(scenario.monthlyCashflow) +
          ' Gewinn / Monat, ' +
          getScenarioAssessment(scenario)
      );
    });

    if (result.warnings.length) {
      lines.push('', 'HINWEISE');
      result.warnings.forEach(function (warning) {
        lines.push('- ' + warning);
      });
    }

    return lines.filter(Boolean).join('\n');
  }

  function updateLeadSummary(section, result) {
    var leadSummary = section.querySelector('[data-roi-lead-summary]');
    if (!leadSummary) return;
    leadSummary.value = buildLeadReport(section, result);
  }

  function renderAll(section) {
    var input = readCalculatorInput(section);
    var result = calculate(input);
    renderResultCards(section, result);
    renderWarnings(section, result);
    renderAssortmentSummary(section);
    renderAssortmentKpis(section, result);
    renderCostSummaries(section, result);
    renderBreakEven(section, result);
    renderScoreCard(section, result);
    renderScenarios(section, input);
    renderReverse(section, result);
    renderWaterfall(section, result);
    updateSummary(section, result);
    updateLeadSummary(section, result);

    var interpretation = section.querySelector('[data-roi-interpretation]');
    if (interpretation) interpretation.textContent = getInterpretation(result);
    return result;
  }

  function setStep(section, nextStep) {
    var steps = section.querySelectorAll('[data-roi-step]');
    var triggers = section.querySelectorAll('[data-roi-step-trigger]');
    var total = steps.length;
    var step = clamp(nextStep, 1, total);
    Array.prototype.forEach.call(steps, function (item) {
      item.classList.toggle('is-active', Number(item.getAttribute('data-roi-step')) === step);
    });
    Array.prototype.forEach.call(triggers, function (trigger) {
      trigger.classList.toggle('is-active', Number(trigger.getAttribute('data-roi-step-trigger')) === step);
    });
    section.setAttribute('data-current-step', String(step));
    var previous = section.querySelector('[data-roi-prev]');
    var next = section.querySelector('[data-roi-next]');
    if (previous) previous.disabled = step === 1;
    if (next) {
      next.textContent = 'Weiter';
      next.classList.toggle('is-hidden', step === total);
    }
    if (step === total) emitTracking('calculator_result_viewed', renderAll(section));
  }

  function updateManualMode(section) {
    var manualToggle = section.querySelector('[data-roi-field="manualUnitsMode"]');
    var manualField = section.querySelector('[data-roi-manual-units]');
    var visitorMode = section.querySelector('[data-roi-visitor-mode]');
    var isManual = Boolean(manualToggle && manualToggle.checked);
    if (manualField) manualField.classList.toggle('is-visible', isManual);
    if (visitorMode) {
      visitorMode.classList.toggle('is-muted', isManual);
      Array.prototype.forEach.call(visitorMode.querySelectorAll('input, select'), function (field) {
        field.disabled = isManual;
      });
    }
  }

  function updateAcquisitionPanels(section) {
    var typeField = section.querySelector('[data-roi-field="acquisitionType"]');
    var type = typeField ? typeField.value : 'purchase';
    Array.prototype.forEach.call(section.querySelectorAll('[data-roi-acquisition-panel]'), function (panel) {
      var allowed = (panel.getAttribute('data-roi-acquisition-panel') || '').split(/\s+/);
      var isActive = allowed.indexOf(type) >= 0;
      panel.classList.toggle('is-hidden', !isActive);
      panel.setAttribute('aria-hidden', isActive ? 'false' : 'true');
      Array.prototype.forEach.call(panel.querySelectorAll('input, select, textarea'), function (field) {
        field.disabled = !isActive;
      });
    });
  }

  function updateLocationCostFields(section) {
    var modelField = section.querySelector('[data-roi-field="locationCostModel"]');
    var model = modelField ? modelField.value : 'none';
    Array.prototype.forEach.call(section.querySelectorAll('[data-roi-location-cost]'), function (row) {
      var allowed = (row.getAttribute('data-roi-location-cost') || '').split(/\s+/);
      var isActive = allowed.indexOf(model) >= 0;
      row.classList.toggle('is-hidden', !isActive);
      row.setAttribute('aria-hidden', isActive ? 'false' : 'true');
      Array.prototype.forEach.call(row.querySelectorAll('input, select, textarea'), function (field) {
        field.disabled = !isActive;
      });
    });
  }

  function updateConditionalFields(section) {
    updateManualMode(section);
    updateAcquisitionPanels(section);
    updateLocationCostFields(section);
  }

  function syncQualityRate(event) {
    var field = event.target;
    if (!field || field.getAttribute('data-roi-field') !== 'locationQuality') return;
    var section = field.closest('[data-snack-roi-calculator]');
    var conversion = section && section.querySelector('[data-roi-field="conversionRate"]');
    if (!conversion) return;
    conversion.value = QUALITY_RATES[field.value] || 6;
  }

  function applyLocationDefaults(section, locationType) {
    var defaults = LOCATION_DEFAULTS[locationType] || LOCATION_DEFAULTS.other;
    var activeDays = section && section.querySelector('[data-roi-field="activeDaysPerMonth"]');
    var activeHours = section && section.querySelector('[data-roi-field="activeHoursPerDay"]');
    var potentialUsers = section && section.querySelector('[data-roi-field="visitorsPerDay"]');
    var quality = section && section.querySelector('[data-roi-field="locationQuality"]');
    var conversion = section && section.querySelector('[data-roi-field="conversionRate"]');
    var itemsPerPurchase = section && section.querySelector('[data-roi-field="itemsPerTransaction"]');
    var assortmentProfile = section && section.querySelector('[data-roi-assortment-profile]');
    if (activeDays) activeDays.value = defaults.activeDaysPerMonth;
    if (activeHours) activeHours.value = defaults.activeHoursPerDay;
    if (potentialUsers) potentialUsers.value = defaults.potentialUsersPerDay;
    if (quality) quality.value = defaults.locationQuality;
    if (conversion) conversion.value = defaults.conversionRatePercent;
    if (itemsPerPurchase) itemsPerPurchase.value = defaults.itemsPerPurchase;
    if (assortmentProfile) {
      assortmentProfile.value = LOCATION_ASSORTMENT_PROFILES[locationType] || LOCATION_ASSORTMENT_PROFILES.other;
      applyAssortmentProfile(section, assortmentProfile.value);
    }
  }

  function syncLocationDefaults(event) {
    var field = event.target;
    if (!field || field.getAttribute('data-roi-field') !== 'locationType') return;
    applyLocationDefaults(field.closest('[data-snack-roi-calculator]'), field.value);
  }

  function canTrack() {
    try {
      if (typeof window === 'undefined') return false;
      if (window.Shopify && window.Shopify.customerPrivacy && typeof window.Shopify.customerPrivacy.userCanBeTracked === 'function') {
        return window.Shopify.customerPrivacy.userCanBeTracked();
      }
      if (window.Cookiebot && window.Cookiebot.consent && window.Cookiebot.consent.statistics) return true;
    } catch (error) {
      return false;
    }
    return false;
  }

  function emitTracking(name, result) {
    if (typeof window === 'undefined') return;
    window.dispatchEvent(
      new CustomEvent(name, {
        detail: result
          ? {
              monthlyCashflow: round(result.monthlyCashflow, 2),
              locationScore: result.locationScore
            }
          : {}
      })
    );
    if (canTrack() && window.dataLayer && Array.isArray(window.dataLayer)) {
      window.dataLayer.push({
        event: name,
        calculator: 'snackautomat_roi',
        monthly_cashflow: result ? round(result.monthlyCashflow, 2) : undefined,
        location_score: result ? result.locationScore : undefined
      });
    }
  }

  function escapeHtml(value) {
    return String(value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function initCalculator(section) {
    if (!section || section.getAttribute('data-roi-initialized') === 'true') return;
    section.setAttribute('data-roi-initialized', 'true');
    var leadState = section.querySelector('[data-roi-lead-success], [data-roi-lead-error]');
    var initialStep = leadState ? 4 : 1;
    section.setAttribute('data-current-step', String(initialStep));

    var started = false;
    section.addEventListener('input', function (event) {
      if (!started) {
        emitTracking('calculator_started');
        started = true;
      }
      syncQualityRate(event);
      syncLocationDefaults(event);
      syncAssortmentProfile(event);
      syncCostDefaults(event);
      updateConditionalFields(section);
      renderAll(section);
    });
    section.addEventListener('change', function (event) {
      syncQualityRate(event);
      syncLocationDefaults(event);
      syncAssortmentProfile(event);
      syncCostDefaults(event);
      updateConditionalFields(section);
      renderAll(section);
    });

    Array.prototype.forEach.call(section.querySelectorAll('[data-roi-step-trigger]'), function (trigger) {
      trigger.addEventListener('click', function () {
        var step = Number(trigger.getAttribute('data-roi-step-trigger'));
        setStep(section, step);
        emitTracking('calculator_step_completed', renderAll(section));
      });
    });

    var previous = section.querySelector('[data-roi-prev]');
    var next = section.querySelector('[data-roi-next]');
    if (previous) {
      previous.addEventListener('click', function () {
        setStep(section, Number(section.getAttribute('data-current-step')) - 1);
      });
    }
    if (next) {
      next.addEventListener('click', function () {
        var current = Number(section.getAttribute('data-current-step')) || 1;
        var total = section.querySelectorAll('[data-roi-step]').length;
        setStep(section, current >= total ? total : current + 1);
        emitTracking('calculator_step_completed', renderAll(section));
      });
    }

    var cta = section.querySelector('[data-roi-cta]');
    if (cta) {
      cta.addEventListener('click', function () {
        emitTracking('calculator_cta_clicked', renderAll(section));
      });
    }
    var leadForm = section.querySelector('.snack-roi__lead-form');
    if (leadForm) {
      leadForm.addEventListener('submit', function () {
        emitTracking('calculator_lead_submitted', renderAll(section));
      });
    }

    var initialLocationType = section.querySelector('[data-roi-field="locationType"]');
    if (initialLocationType) applyLocationDefaults(section, initialLocationType.value);
    var initialAcquisitionType = section.querySelector('[data-roi-field="acquisitionType"]');
    if (initialAcquisitionType) applyAcquisitionDefaults(section, initialAcquisitionType.value);
    var initialLocationCostModel = section.querySelector('[data-roi-field="locationCostModel"]');
    if (initialLocationCostModel) applyLocationCostDefaults(section, initialLocationCostModel.value);
    var initialPaymentProfile = section.querySelector('[data-roi-payment-profile]');
    if (initialPaymentProfile) applyPaymentProfile(section, initialPaymentProfile.value);
    var initialOperationProfile = section.querySelector('[data-roi-operation-profile]');
    if (initialOperationProfile) applyOperationProfile(section, initialOperationProfile.value);
    var initialAssortmentProfile = section.querySelector('[data-roi-assortment-profile]');
    if (initialAssortmentProfile) applyAssortmentProfile(section, initialAssortmentProfile.value);
    updateConditionalFields(section);
    renderAll(section);
    setStep(section, initialStep);
    if (leadState && typeof leadState.scrollIntoView === 'function') {
      window.setTimeout(function () {
        leadState.scrollIntoView({ block: 'center' });
        if (typeof leadState.focus === 'function') leadState.focus();
      }, 80);
    }
  }

  function initAll() {
    if (typeof document === 'undefined') return;
    Array.prototype.forEach.call(document.querySelectorAll('[data-snack-roi-calculator]'), initCalculator);
  }

  if (typeof document !== 'undefined') {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }
    document.addEventListener('shopify:section:load', function (event) {
      initCalculator(event.target && event.target.querySelector('[data-snack-roi-calculator]'));
    });
  }

  return {
    calculate: calculate,
    scenarioResults: scenarioResults,
    buildInput: buildInput,
    normalizeCategories: normalizeCategories,
    loanPayment: loanPayment,
    locationDefaults: LOCATION_DEFAULTS,
    locationAssortmentProfiles: LOCATION_ASSORTMENT_PROFILES,
    assortmentProfiles: ASSORTMENT_PROFILES,
    formatMoney: formatMoney,
    _private: {
      toNumber: toNumber,
      scoreLocation: scoreLocation
    }
  };
});
